import {
	BLACK_MOVED,
	WHITE_MOVED,
	BLACK_CASTLED,
	WHITE_CASTLED,
	BLACK_CAPTURED_WHITE,
	WHITE_CAPTURED_BLACK,
	WHITE_PROMOTED_BY_MOVE,
	BLACK_PROMOTED_BY_MOVE,
	WHITE_PROMOTED_BY_CAPTURE,
	BLACK_PROMOTED_BY_CAPTURE,
	SET_WHITE_CASTLE_STATE,
	SET_BLACK_CASTLE_STATE,
	SET_GAME_OVER,
	ADD_HISTORY,
	RESET_HISTORY,
	INITIAL_BOARD,
} from "../actions/actionTypes";

// Pieces index representation
// Rook     		[0], [7]
// Kinght   		[1], [6]
// Bishop   		[2], [5]
// Queen    		[3],
// King     		[4],
// Pawn/promotion	[8], [9], [10], [11], [12], [13], [14], [15]

// canWhiteCastle: [left, right],
// canBlackCastle: [left, right],

const initialState = {
	blackPosition: [18, 28, 38, 48, 58, 68, 78, 88, 17, 27, 37, 47, 57, 67, 77, 87],
	whitePosition: [11, 21, 31, 41, 51, 61, 71, 81, 12, 22, 32, 42, 52, 62, 72, 82],
	blackPiece: [
		"RK_B",
		"KT_B",
		"BP_B",
		"QN_B",
		"KG_B",
		"BP_B",
		"KT_B",
		"RK_B",
		"PN_B",
		"PN_B",
		"PN_B",
		"PN_B",
		"PN_B",
		"PN_B",
		"PN_B",
		"PN_B",
	],
	whitePiece: [
		"RK_W",
		"KT_W",
		"BP_W",
		"QN_W",
		"KG_W",
		"BP_W",
		"KT_W",
		"RK_W",
		"PN_W",
		"PN_W",
		"PN_W",
		"PN_W",
		"PN_W",
		"PN_W",
		"PN_W",
		"PN_W",
	],
	history: [],
	canWhiteCastle: [true, true],
	canBlackCastle: [true, true],
	isWhiteTurn: true,
	gameOver: "",
};

function itemReducer(state = initialState, action) {
	switch (action.type) {
		case INITIAL_BOARD:
			return {
				...state,
				whitePosition: action.payload.whitePosition,
				blackPosition: action.payload.blackPosition,
				whitePiece: action.payload.whitePiece,
				blackPiece: action.payload.blackPiece,
				canWhiteCastle: action.payload.canWhiteCastle,
				canBlackCastle: action.payload.canBlackCastle,
				history: action.payload.history,
				isWhiteTurn: action.payload.isWhiteTurn,
				gameOver: action.payload.gameOver,
			};
		case SET_GAME_OVER:
			console.log("SET_GAME_OVER", action.payload.gameOver);
			return { ...state, gameOver: action.payload.gameOver };

		case ADD_HISTORY:
			console.log("ADD_HISTORY", action.payload.history);
			return { ...state, history: [...state.history, action.payload.history] };

		case RESET_HISTORY:
			return { ...state, history: [] };

		case SET_WHITE_CASTLE_STATE:
			return { ...state, canWhiteCastle: action.payload.canWhiteCastle };

		case SET_BLACK_CASTLE_STATE:
			return { ...state, canBlackCastle: action.payload.canBlackCastle };

		case BLACK_MOVED:
		case BLACK_CASTLED:
			return { ...state, blackPosition: action.payload.blackPosition, isWhiteTurn: true };

		case WHITE_MOVED:
		case WHITE_CASTLED:
			return { ...state, whitePosition: action.payload.whitePosition, isWhiteTurn: false };

		case BLACK_CAPTURED_WHITE:
			return {
				...state,
				whitePosition: action.payload.whitePosition,
				blackPosition: action.payload.blackPosition,
				isWhiteTurn: true,
			};

		case WHITE_CAPTURED_BLACK:
			return {
				...state,
				whitePosition: action.payload.whitePosition,
				blackPosition: action.payload.blackPosition,
				isWhiteTurn: false,
			};

		case WHITE_PROMOTED_BY_MOVE:
			return {
				...state,
				whitePiece: action.payload.whitePiece,
				whitePosition: action.payload.whitePosition,
				isWhiteTurn: false,
			};
		case BLACK_PROMOTED_BY_MOVE:
			return {
				...state,
				blackPiece: action.payload.blackPiece,
				blackPosition: action.payload.blackPosition,
				isWhiteTurn: true,
			};
		case WHITE_PROMOTED_BY_CAPTURE:
			return {
				...state,
				whitePiece: action.payload.whitePiece,
				whitePosition: action.payload.whitePosition,
				blackPosition: action.payload.blackPosition,
				isWhiteTurn: false,
			};
		case BLACK_PROMOTED_BY_CAPTURE:
			return {
				...state,
				blackPiece: action.payload.blackPiece,
				whitePosition: action.payload.whitePosition,
				blackPosition: action.payload.blackPosition,
				isWhiteTurn: true,
			};

		default:
			return state;
	}
}

export default itemReducer;
